import { styled } from "@mui/material";
import { FontSize, getFontStyle } from "~/common/components/materialInput/Fonts";

export const AccordionGroup = styled("div")({
  "& + &": {
    marginTop: "24px",
  },
});
export const AccordionGroupTitle = styled("p")({
  margin: "0 16px 16px",
  ...getFontStyle(FontSize.HeadlineMedium),
  fontWeight: "bold",
});
